module.exports = __webpack_public_path__ + "assets/img/thumb-LJ-Hooker-eBook.215119f5.png";